import React, { useMemo } from 'react';
import styled from 'styled-components';

import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'querystring';
import { useAppContext } from '@prisjakt/ui-app-context';
import { ProductsHeader } from 'src/components/products-header';
import LayoutButtons from 'src/components/layout-buttons';
import { SortedBy } from '../sorted-by';

import { LayoutMode } from 'src/components/layout-buttons/types';

import FilterDropdown, { Option } from '../../../../components/filter-dropdown';

import { MAX_RESULTS } from '../../constants';
import { DesktopOnly } from 'src/ui/block';

type Props = {
  activeLayout?: LayoutMode;
  setLayout: (layout: LayoutMode) => void;
  productsCount?: number | null;
  currentSort: string;
  sortOptions: Option[];
  newSearch: boolean;
};

export const SearchResultsProductsHeader = (props: Props) => {
  const { market, t } = useAppContext();
  const history = useHistory();
  const location = useLocation();

  const handleFilterChange = (option: Option) => {
    const qs = queryString.decode(location.search.substr(1));

    qs.sort = option.value as string;

    history.push(`${location.pathname}?${queryString.encode(qs)}`);
  };

  const {
    activeLayout,
    productsCount = 0,
    setLayout,
    currentSort,
    sortOptions,
    newSearch,
  } = props;

  const supportedViewModes = useMemo(
    () => [LayoutMode.GRID, LayoutMode.LIST, LayoutMode.COMPACT_LIST],
    []
  );

  const count =
    (productsCount || 0) >= MAX_RESULTS
      ? `${MAX_RESULTS.toLocaleString(market.localeStandard)}+`
      : (productsCount || 0).toLocaleString(market.localeStandard);

  return (
    <>
      <ProductsHeader
        displayOptions={
          <>
            <LayoutButtons
              layoutModes={supportedViewModes}
              activeLayout={activeLayout || LayoutMode.GRID}
              setLayout={currentLayout => setLayout(currentLayout)}
            />
          </>
        }
        sortOptions={
          <DesktopOnly>
            {newSearch ? (
              <SortedBy />
            ) : (
              <DropDown
                defaultSelected={sortOptions.find(
                  option => option.value === currentSort
                )}
                title={t('common', 'sort.title')}
                options={sortOptions}
                onFilterChange={handleFilterChange}
              />
            )}
          </DesktopOnly>
        }
        title={`${t('search', 'products.title')} (${count})`}
      />
    </>
  );
};

const DropDown = styled(FilterDropdown)`
  margin-bottom: 0;
`;
